import _ from 'lodash'
import { IDB_reportsReadAll, IDB_reportsWrite } from '../IDB/IDB.table.report'
import type { NReports } from './Rpts.types'
import type { Sync_SyncResult } from '../Sync/Sync.master'
import { Logg_createLogger } from '../Logg/Logg.Logger'

export async function Rpts_sync(data: Sync_SyncResult) {
    const { reports } = data.response

    const logger = Logg_createLogger('Rpts_sync')

    if (reports == null || reports.length === 0) {
        logger.log('no reports downloaded to sync')
        return
    }

    const reportClientIds = reports.map((r) => r.clientId)
    logger.log('preparing downloaded reports to be written', { reportClientIds })

    const localReportList = await IDB_reportsReadAll()
    const localReportClientIds = localReportList.map((r) => r.clientId)
    logger.log(`read all local reports to compare to downloaded reports`, { localReportClientIds })

    // We can end up with duplicates if we create a report locally, send it to the server and the
    // receive it back on the next sync. In order to detect & avoid duplicates we store the unique id
    // from the server as a 'onlineId' property on the local reports, and then check for each report
    // from the server whether we already have local report with the matching 'onlineId'. If we do
    // then we update the incoming report's 'reportId' (which is the indexeddb key path property) to
    // match that of the local report so that the local report is overwritten by the data coming from
    // the server.
    //
    // This code works with the upload report code which waits for the response from the server and
    // sets the onlineId on the local report to the id coming from the server response
    const newReports: NReports.TSyncReport[] = reports.map((serverReport) => {
        const newReport: NReports.TSyncReport = {
            ...serverReport,
            // Continue to make sure that local reports have an 'onlineId' property that matches the 'id'
            // coming from the server
            onlineId: serverReport.id,
            // All synced reports are necessarily already uploaded
            uploaded: true,
        }

        // Find local report with matching id
        const localReport = localReportList.find((report) => report.onlineId === serverReport.id)

        if (localReport != null) {
            logger.log('found local copy of downloaded report', {
                reportClientId: localReport.clientId,
                reportId: serverReport.id,
            })

            // Make sure to overwrite the existing report by using the same primary key
            newReport.reportId = localReport.reportId
        }

        newReport.items.forEach((item) => {
            // Make sure each item has images & a note for data consistency in the rest of the app
            item.images = item.images || []
            item.notes = item.notes || ''
        })

        return newReport
    })

    await IDB_reportsWrite(logger, newReports)
}
